module.exports = __webpack_public_path__ + "img/score.2f9841c0.png";